var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"card"},[(_vm.isReady)?_c('vue-tailwind-color-picker',{attrs:{"value":_vm.normalizedValue,"hide-swatches":_vm.hideSwatches,"swatches":_vm.swatches},on:{"update:swatches":function($event){_vm.swatches=$event},"input":(value) => _vm.$emit('input', value)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }